import { render, staticRenderFns } from "./OrderRemarkList.vue?vue&type=template&id=6f365b43&scoped=true"
import script from "./OrderRemarkList.vue?vue&type=script&lang=js"
export * from "./OrderRemarkList.vue?vue&type=script&lang=js"
import style0 from "./OrderRemarkList.vue?vue&type=style&index=0&id=6f365b43&prod&scoped=true&lang=css"
import style1 from "./OrderRemarkList.vue?vue&type=style&index=1&id=6f365b43&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f365b43",
  null
  
)

export default component.exports